export function nfCurrencyTransform(
  amount: number | null,
  formatMoney: (arg1: number | null) => string,
): string {
  if (amount === null) {
    return 'N/A';
  }
  let negative = false;

  if (amount < 0) {
    amount = -amount;
    negative = true;
  }

  const value = formatMoney(amount);
  if (value === 'N/A') {
    return value;
  }
  return negative ? `(${value})` : value;
}
